import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { PractitionerResponse } from '../../models/practitioner.interface';

@Injectable({
  providedIn: 'root',
})
export class PractitionerService {
  loggedInPractitioner: PractitionerResponse | undefined;
  constructor(private readonly http: HttpClient) { }

  getPractitionerByName(practitionerName: string): Observable<{ response: PractitionerResponse[] }> {
    return this.http.get<{ response: PractitionerResponse[] }>(`${environment.cva_url}${API_ROUTES.PRACTITIONER}/search/${practitionerName}`);
  }

  getPractitionerByHpiId(hpiId: string): Observable<PractitionerResponse> {
    if (this.loggedInPractitioner) {
      return of(this.loggedInPractitioner);
    } else {
      return this.http.get<{ response: PractitionerResponse }>(`${environment.cva_url}${API_ROUTES.PRACTITIONER}/hpi-id/${hpiId}`).pipe(
        map(response => response.response),
        tap(data => this.loggedInPractitioner = data)
      );
    }
  }

  geAlltPractitioners(): Observable<{ response: PractitionerResponse[] }> {
    return this.http.get<{ response: PractitionerResponse[] }>(`${environment.cva_url}${API_ROUTES.PRACTITIONER}?all=true`);
  }
}
